import {useEffect, useState} from 'react'
import {trackViewProduct, trackViewProductSet} from '../../../tracking/analytics'

import {getDisplayPrice, isProductSet} from '../../../utils/product-utils'
import useEffectEvent from '../../../hooks/use-effect-event'
import {useCurrentCustomer} from '../../../hooks/use-current-customer'

const useTrackViewPDP = (product) => {
    const [trackedId, setTrackedId] = useState(null)
    const {isCustomNetPriceEnabled} = useCurrentCustomer().data

    const onProductChange = useEffectEvent((product) => {
        // only track if product exists
        // only track once
        if (!product || trackedId === product?.id) {
            return
        }

        if (isProductSet(product)) {
            // track product set and add salePrice to each product
            const enrichedProduct = {
                ...product,
                setProducts: product.setProducts.map((setProduct) => {
                    const lineItem = product.productLineItems?.find(
                        (item) => item.variantId === setProduct.id
                    )
                    return {
                        ...setProduct,
                        salePrice: lineItem?.adjustedPrice || lineItem?.price
                    }
                })
            }
            trackViewProductSet(enrichedProduct)
        } else {
            // track cart and add salePrice to the product
            const {displayPrice: sale_price} = getDisplayPrice(
                product,
                false,
                isCustomNetPriceEnabled
            )
            const enrichedProduct = {
                ...product,
                salePrice: sale_price
            }
            trackViewProduct(enrichedProduct)
        }
        setTrackedId(product.id)
    })
    useEffect(() => {
        onProductChange(product)
    }, [product, onProductChange])
}

export default useTrackViewPDP
